// Shared recovery scheduling only; each page retains its existing message and betting logic.
export function createSocketRecovery({ connect, refresh, isStopped, target = window }) {
  let timer = null
  let attempts = 0
  let disposed = false
  let refreshing = null
  let refused = false
  const stopped = () => disposed || isStopped()
  function retry(event = {}) {
    if ([1008, 3001, 4001, 4003].includes(Number(event.code))) {
      refused = true
      if (timer !== null) target.clearTimeout(timer)
      timer = null
      return
    }
    if (stopped() || refused || timer !== null) return
    const delay = Math.min(30000, 1000 * 2 ** Math.min(attempts++, 5))
    timer = target.setTimeout(() => {
      timer = null
      if (!stopped() && !refused) Promise.resolve().then(connect).catch(() => retry())
    }, delay)
  }
  function opened(reconnect) {
    attempts = 0
    refused = false
    if (timer !== null) target.clearTimeout(timer)
    timer = null
    if (reconnect && refresh && !refreshing && !stopped()) {
      refreshing = Promise.resolve().then(refresh).catch(() => {}).finally(() => { refreshing = null })
    }
  }
  function online() {
    if (stopped() || refused) return
    if (timer !== null) target.clearTimeout(timer)
    timer = null
    attempts = 0
    Promise.resolve().then(connect).catch(() => retry())
  }
  target.addEventListener('online', online)
  return { retry, opened, dispose() {
    disposed = true
    if (timer !== null) target.clearTimeout(timer)
    timer = null
    target.removeEventListener('online', online)
  } }
}
